import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=619f20c8&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('619f20c8')) {
      api.createRecord('619f20c8', component.options)
    } else {
      api.reload('619f20c8', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=619f20c8&", function () {
      api.rerender('619f20c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/Index.vue"
export default component.exports